import { Grid } from '@mui/material';
import { Autocomplete } from '../../../../../ui/components/pure/autocomplete/autocomplete.component';
import { CourierFormModal } from '../../../components/courier-form-modal.component';
import { rowGroupStyle } from '../../../components/courier-form.styles';
import { BatchExportCouriersActionProps, useBatchExportCouriersAction } from './batch-export-couriers-action.hook';

export function BatchExportCouriersAction(props: BatchExportCouriersActionProps) {
  const { state, handlers, control, handleSubmit, unitMenuItems, loading } = useBatchExportCouriersAction(props);

  return (
    <CourierFormModal
      title="Batch export"
      loading={loading}
      saving={state.exporting}
      error={state.error}
      submitLabel="Export"
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      <Grid container spacing={2} style={rowGroupStyle}>
        <Grid size={12}>
          Select a carrier from the list below and press export to extract a CSV of all couriers for the selected
          carrier.
        </Grid>
        <Grid size={12}>
          <Autocomplete
            control={control}
            name="groupID"
            required="Choose a carrier to export."
            label="Carrier"
            placeholder="Carrier"
            options={unitMenuItems}
            getOptionLabel={(option) => option.label}
            loading={loading}
            fullWidth
          />
        </Grid>
      </Grid>
    </CourierFormModal>
  );
}
